import React from "react";
import { Button, DatePicker, Space, message } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import {
  useDateFilter,
  DATE_FILTER_FORMAT,
} from "../../Contexts/DateFilterContext";
import { UndoOutlined, DownOutlined, FilterFilled } from "@ant-design/icons";
import "./style.css";

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

const { RangePicker } = DatePicker;

const DateFilter = () => {
  const { selection, setSelection, resetSelection } = useDateFilter();

  const getPickerValue = (pickerType) =>
    selection?.type === pickerType && selection.value
      ? dayjs(selection.value)
      : null;

  const rangeValue =
    selection?.type === "custom" && Array.isArray(selection.value)
      ? selection.value.map((v) => dayjs(v))
      : null;

  const handleChange = (value, pickerType) => {
    if (!value) {
      resetSelection();
      return;
    }

    let from;
    let to;
    let storedValue;

    switch (pickerType) {
      case "date":
        from = dayjs(value).startOf("day");
        to = dayjs(value).endOf("day");
        storedValue = from.format("YYYY-MM-DD");
        break;
      case "week":
        from = dayjs(value).startOf("week");
        to = dayjs(value).endOf("week");
        storedValue = from.format("YYYY-MM-DD");
        break;
      case "month":
        from = dayjs(value).startOf("month");
        to = dayjs(value).endOf("month");
        storedValue = from.format("YYYY-MM-DD");
        break;
      case "custom": {
        if (value.length !== 2 || !value[0] || !value[1]) return;

        const diff = dayjs(value[1]).diff(dayjs(value[0]), "day");
        if (diff > 30) {
          message.error("You cannot select a range longer than 30 days.");
          return;
        }
        from = dayjs(value[0]).startOf("day");
        to = dayjs(value[1]).endOf("day");
        storedValue = [from.format("YYYY-MM-DD"), to.format("YYYY-MM-DD")];
        break;
      }
      default:
        return;
    }

    setSelection({
      type: pickerType,
      value: storedValue,
      from: from.format(DATE_FILTER_FORMAT),
      to: to.format(DATE_FILTER_FORMAT),
    });
  };

  return (
    <div className="date-filter">
      <Space>
        <FilterFilled
          style={{ fontSize: "16px", padding: "8px", color: "#A2A8B0" }}
        />
        <DatePicker
          value={getPickerValue("date")}
          suffixIcon={<DownOutlined style={{ color: "#2662D9" }} />}
          placeholder="Date"
          picker="date"
          onChange={(value) => handleChange(value, "date")}
        />
        <DatePicker
          value={getPickerValue("week")}
          suffixIcon={<DownOutlined style={{ color: "#2662D9" }} />}
          placeholder="Week"
          picker="week"
          onChange={(value) => handleChange(value, "week")}
        />
        <DatePicker
          value={getPickerValue("month")}
          suffixIcon={<DownOutlined style={{ color: "#2662D9" }} />}
          placeholder="Month"
          picker="month"
          onChange={(value) => handleChange(value, "month")}
        />
        <RangePicker
          value={rangeValue}
          suffixIcon={<DownOutlined style={{ color: "#2662D9" }} />}
          placeholder={["Start Date", "End Date"]}
          onChange={(value) => handleChange(value, "custom")}
        />

        <Button danger icon={<UndoOutlined />} onClick={resetSelection}>
          Reset
        </Button>
      </Space>
    </div>
  );
};

export default DateFilter;
